import React, { ReactNode } from 'react';

interface MainContentProps {
  children: ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => (
  <main
    className="ml-[270px] mr-auto"
    style={{
      flex: 1,
      padding: '40px 48px',
      minHeight: '100vh',
      overflowY: 'auto',
      background: '#ffffff',
    }}
  >
    <div className='max-w-[800px] mx-auto'>{children}</div>
  </main>
);

export default MainContent; 